module.exports = __webpack_public_path__ + "img/emoji_85.4c0e2e4a.png";